<template>
  <div class="flex flex-col items-center w-full max-w-md mx-auto">
    <div
      class="flex items-center justify-center w-24 h-24 overflow-hidden font-bold transition bg-white rounded dark:bg-gray-800 ring-2"
      :class="{
        'ring-gray-300 dark:ring-gray-700': lastRoll
          ? (rollIsMax(lastRoll) == false && rollIsMin(lastRoll) == false) ||
            highlightMinAndMaxRolls == false
          : true,
        'ring-green-600': lastRoll
          ? rollIsMax(lastRoll) && highlightMinAndMaxRolls
          : false,
        'ring-red-600': lastRoll
          ? rollIsMin(lastRoll) && highlightMinAndMaxRolls
          : false,
      }"
    >
      <transition name="roll-total" mode="out-in">
        <div class="text-3xl" v-if="lastRoll" :key="lastRoll.timestamp">
          {{ lastRoll.rollData.total }}
        </div>
      </transition>
    </div>
    <div class="h-8 mt-4 text-lg font-semibold">
      <transition name="roll-notation" mode="out-in">
        <div v-if="lastRoll" :key="lastRoll.timestamp">
          {{ lastRoll.rollData.output }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { get } from "vuex-pathify";
import helpers from "../helpers";

export default {
  name: "RollBox",
  computed: {
    lastRoll: get("lastRoll"),
    highlightMinAndMaxRolls: get("highlightMinAndMaxRolls"),
  },
  methods: {
    rollIsMax: helpers.rollIsMax,
    rollIsMin: helpers.rollIsMin,
  },
};
</script>

<style>
.roll-total-enter-active,
.roll-total-leave-active {
  transition: all 0.1s;
}
.roll-total-enter,
.roll-total-leave-to {
  opacity: 0;
  transform: scale(0);
}

.roll-notation-enter-active,
.roll-notation-leave-active {
  transition: all 0.1s;
}
.roll-notation-enter,
.roll-notation-leave-to {
  opacity: 0;
}
</style>
